import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBalkon = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M12 10h16v19H12z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M8 22h24v10H8z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M14 12h5v10h-5zM21 12h5v10h-5z"
    />
    <path
      fill="#85E3F9"
      d="M12 24v6h-2v-6zM15 24v6h-2v-6zM18 24v6h-2v-6zM21 24v6h-2v-6zM24 24v6h-2v-6zM27 24v6h-2v-6zM30 24v6h-2v-6z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBalkon);

export default ForwardRef;
